import { useState } from "react";

function AccordionSection({
  icon,
  iconBgColor = "blue",
  label,
  title,
  subtitle,
  price,
  defaultOpen = false,
  children,
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const iconBgMap = {
    blue: "bg-blue-100",
    purple: "bg-purple-100",
    amber: "bg-amber-100",
  };

  const iconColorMap = {
    blue: "text-blue-600",
    purple: "text-purple-600",
    amber: "text-amber-600",
  };

  return (
    <div className="bg-gray-50 rounded-xl overflow-hidden">
      <button
        type="button"
        className="w-full px-5 py-4 flex items-center justify-between hover:bg-gray-100 transition-colors cursor-pointer"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-3">
          <div
            className={`w-8 h-8 ${iconBgMap[iconBgColor]} rounded-lg flex items-center justify-center flex-shrink-0`}
          >
            <span className={iconColorMap[iconBgColor]}>{icon}</span>
          </div>
          <div className="text-left">
            {label && (
              <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest leading-none mb-1">
                {label}
              </p>
            )}
            <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
            {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
          </div>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <span className="text-sm font-semibold text-gray-900">{price}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`text-gray-400 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </div>
      </button>

      <div
        className={`transition-all duration-200 ease-out overflow-hidden ${
          isOpen ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        {children}
      </div>
    </div>
  );
}

export default AccordionSection;
